/** @format */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxFudisModule } from '@funidata/ngx-fudis';
import { TranslateModule } from '@ngx-translate/core';
import { UIRouterModule } from '@uirouter/angular';
import { SisCommonModule } from 'sis-common';
import { SisComponentsModule } from 'sis-components';
import { StudentCommonModule } from '../common/common.module';
import { ApplicationsModule } from './applications/applications.module';
import { CancelApplicationModalComponent } from './applications/cancelApplicationModal.component';
import { GraduationWizardComponent } from './applications/graduation-wizard/graduation-wizard.component';
import { GraduationWizardStep1Component } from './applications/graduation-wizard/step1/graduation-wizard-step1.component';
import { GraduationWizardStep2Component } from './applications/graduation-wizard/step2/graduation-wizard-step2.component';
import { GraduationWizardStep3Component } from './applications/graduation-wizard/step3/graduation-wizard-step3.component';
import { ShowModuleContentApplicationModalComponent } from './applications/showModuleContentApplicationModal.component';
import { ShowModuleContentApplicationModalDirective } from './applications/showModuleContentApplicationModal.dir.upgraded';
import { AttainmentModule } from './attainment/attainment.module';
import { StudentAttainmentNodeWrapperComponent } from './attainments/student-attainments/student-attainment-node-wrapper/student-attainment-node-wrapper.component';
import { StudentAttainmentsComponent } from './attainments/student-attainments/student-attainments.component';
import { BasicInfoPersonalInfoDetailsComponent } from './basic-info/basic-info-personal-info-details/basic-info-personal-info-details.component';
import { BasicInfoPersonalInfoComponent } from './basic-info/basic-info-personal-info/basic-info-personal-info.component';
import { BasicInfoComponent } from './basic-info/basic-info.component';
import { ContactInformationComponent } from './basic-info/contact-information/contact-information.component';
import { ProfileEnrolmentsComponent } from './enrolments/profile-enrolments.component';
import { GrantsPageComponent } from './payments-and-grants/grants/grants-page/grants-page.component';
import { GrantsTableComponent } from './payments-and-grants/grants/grants-table/grants-table.component';
import { StudyYearGrantsComponent } from './payments-and-grants/grants/study-year-grants/study-year-grants.component';
import { PaymentAndGrantTabsComponent } from './payments-and-grants/payment-and-grant-tabs/payment-and-grant-tabs.component';
import { OiliPaymentsTableComponent } from './payments-and-grants/payments/oili-payments-table/oili-payments-table.component';
import { PaymentsComponent } from './payments-and-grants/payments/payments.component';
import { StudyYearPaymentsComponent } from './payments-and-grants/payments/study-year-payments/study-year-payments.component';
import { TuitionFeePaymentsTableComponent } from './payments-and-grants/payments/tuition-fee-payments-table/tuition-fee-payments-table.component';
import { StudentPersonGroupsComponent } from './personGroups/student-person-groups/student-person-groups.component';
import { ProfileSecondaryNavigationComponent } from './profile-secondary-navigation/profile-secondary-navigation.component';
import { ProfileShellComponent } from './profile-shell/profile-shell.component';
import { profileStates } from './profile.route-ng';
import { StudyRightsModule } from './studyRights/study-rights.module';

@NgModule({
    declarations: [
        CancelApplicationModalComponent,
        ContactInformationComponent,
        BasicInfoComponent,
        BasicInfoPersonalInfoComponent,
        BasicInfoPersonalInfoDetailsComponent,
        ProfileSecondaryNavigationComponent,
        ProfileShellComponent,
        GrantsPageComponent,
        GrantsTableComponent,
        PaymentAndGrantTabsComponent,
        PaymentsComponent,
        OiliPaymentsTableComponent,
        ShowModuleContentApplicationModalComponent,
        ShowModuleContentApplicationModalDirective,
        StudyYearGrantsComponent,
        StudyYearPaymentsComponent,
        TuitionFeePaymentsTableComponent,
        StudentAttainmentsComponent,
        StudentAttainmentNodeWrapperComponent,
        StudentPersonGroupsComponent,
        ProfileEnrolmentsComponent,
        GraduationWizardComponent,
        GraduationWizardStep1Component,
        GraduationWizardStep2Component,
        GraduationWizardStep3Component,
    ],
    imports: [
        BrowserModule,
        SisCommonModule,
        SisComponentsModule,
        StudentCommonModule,
        TranslateModule.forChild(),
        UIRouterModule.forChild({ states: profileStates }),
        ApplicationsModule,
        StudyRightsModule,
        AttainmentModule,
        NgxFudisModule,
    ],
})
export class ProfileModule {}
